import AcceptancesCard from './AcceptancesCard'

export default AcceptancesCard
